import React, { useState, useEffect } from "react";
import {
  TextField,
  FormControlLabel,
  FormControl,
  Select,
  Checkbox,
  MenuItem,
  TextareaAutosize,
  InputLabel,
  FormGroup,
  Typography,
  Radio,
} from "@material-ui/core/";
import moment from "moment";
import countryCodes from "country-codes-list";
import { countries } from "country-flags-svg";
import { useSelector, useDispatch } from "react-redux";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Aux from "../../../hoc/Auxilliary";
import localizedStrings from "../../../utils/localize";
import { parseISO } from "date-fns";

import { makeStyles } from "@material-ui/core/";

const useStyle = makeStyles((theme) => ({
  datepicker: {
    transform: "scaleX(1)",
    borderBottomColor: "lightgrey",
  },
  root: {
    "& label": {
      fontSize: "100px",
    },
    "& .MuiFormLabel-root": {
      fontSize: "1em",
    },
    "& .MuiInputLabel-shrink": {
      // fontSize:"1.8em",
      transform: "translate(0, 1.5px) scale(1)",
      transformOrigin: "top left",
    },
  },
  select: {
    "&.MuiInputLabel-shrink": {
      transform: "translate(0, 1.5px) scale(0.75)",
      transformOrigin: "top left",
      fontSize: "17px",
    },
  },
}));
const InputFiled = (props) => {
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  const classes = useStyle(props);
  let message = null;
  const validateField = (props) => {
  let  errmsg = localizedStrings.general.invalidnamemsg;
    const nameRegex = /^\p{Lu}[\p{L}\p{M}' -]*$/u;
    if (
      props.elementConfig.name === "firstname" ||
      props.elementConfig.name === "lastname" 
    ) {
      message = props.elementConfig.name === "firstname"
        ? (localizedStrings.general.invalidfirstname || `${props.elementConfig.label} ${errmsg}`)
        : (localizedStrings.general.invalidlastname || `${props.elementConfig.label} ${errmsg}`);
      return !nameRegex.test(props.value);
    }
    if (
      (props.elementConfig.name === "usb_maidenname" ||
        props.elementConfig.name === "usb_formername" ||
        props.elementConfig.name === "middlename" ||
        props.elementConfig.name === "ses_preferredname") &&
      props.value
    ) {
      if (props.elementConfig.name === "ses_preferredname") {
        message = localizedStrings.general.invalidpreferredname || `${props.elementConfig.label} ${errmsg}`;
      } else if (props.elementConfig.name === "usb_maidenname") {
        message = localizedStrings.general.invalidmaidenname || `${props.elementConfig.label} ${errmsg}`;
      } else if (props.elementConfig.name === "usb_formername") {
        message = localizedStrings.general.invalidformername || `${props.elementConfig.label} ${errmsg}`;
      } else if (props.elementConfig.name === "middlename") {
        message = localizedStrings.general.invalidmiddlename || `${props.elementConfig.label} ${errmsg}`;
      } else {
        message = `${props.elementConfig.label} ${errmsg}`;
      }
      return !nameRegex.test(props.value);
    }

    if (
      props.elementConfig.name === "firstname" ||
      props.elementConfig.name === "middlename" ||
      props.elementConfig.name === "lastname" ||
      props.elementConfig.name === "gurd_firstname" ||
      props.elementConfig.name === "gurd_middlename" ||
      props.elementConfig.name === "gurd_lastname"
    ) {
      let regex = /^[\p{L}\p{M}' -]*$/u;

      // message = `Invalid ${props.elementConfig.label} should contain only albhabets`;
      return props.value && props.value.length < 3
        ? (message = `The ${props.elementConfig.label} should contain a minimum of three characters`)
        : props.value && !props.value.match(regex)
        ? true
        : false;
    }
    if (
      props.elementConfig.name === "gurd_emailaddress1" ||
      props.elementConfig.name === "emailaddress2"
    ) {
      let emailExp =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailExp.test(String(props.value).toLowerCase())
        ? false
        : (message = `${localizedStrings.general.invalidemail}`);
    }

    if (props.elementConfig.name === "eslsca_arabicname") {
      let regex = /[\u0600-\u06FF]/;
      message = `Invalid ${props.elementConfig.label} should contain only arabic letters`;
      return props.value.length < 8
        ? (message = `${props.elementConfig.label} should contain minimum of eight characters`)
        : !props.value.match(regex)
        ? true
        : false;
    }
    if (props.isValid !== undefined && props.value.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  let inputElement = null;
  switch (props.inputType) {
    case "input":
      inputElement = (
        <Aux>
         {props.display === "block" && props.elementConfig.aboveText && (
            <>
              <br />
              <div dangerouslySetInnerHTML={{ __html: props.elementConfig.aboveText }} />
            </>
          )}
          {props.display === "block" && props.elementConfig.belowLabelText && (
            <>
              {props.elementConfig.label && (
                <Typography
                  component="label"
                  style={{
                    fontSize: "0.75rem",
                    color: "rgba(0, 0, 0, 0.54)",
                    marginBottom: "4px",
                    display: "block",
                    marginTop: "16px",
                  }}
                >
                  {props.elementConfig.label}
                </Typography>
              )}
             <Typography
                style={{
                  fontSize: "0.75rem",
                  color: "rgba(0, 0, 0, 0.6)",
                  marginBottom: "-14px",
                }}
              >
             {props.elementConfig.belowLabelText}
              </Typography>
              <TextField
                margin="normal"
                value={props.value}
                onChange={props.changed}
                {...props.elementConfig}
                label={undefined}
                color="secondary"
                InputProps={{
                  endAdornment: props.icon,
                }}
                inputProps={{
                  maxLength: props.maxLength ? props.maxLength : 50,
                  ...(props.elementConfig.type === "number" && {
                    onKeyPress: (e) => {
                      if (!/^\d*$/.test(e.key)) {
                        e.preventDefault(); // Prevent non-numeric input
                      }
                    },
                  }),
                }}
                style={{ display: props.display }}
              />
            </>
         )}
          {!(props.display === "block" && props.elementConfig.belowLabelText) && (
            <TextField
              margin="normal"
              value={props.value}
              onChange={props.changed}
              {...props.elementConfig}
              color="secondary"
              InputProps={{
                endAdornment: props.icon,
              }}
              inputProps={{
                maxLength: props.maxLength ? props.maxLength : 50,
                ...(props.elementConfig.type === "number" && {
                  onKeyPress: (e) => {
                    if (!/^\d*$/.test(e.key)) {
                      e.preventDefault(); // Prevent non-numeric input
                    }
                  },
                }),
              }}
              style={{ display: props.display }}
            />
          )}
          
          {validateField(props) ? (
            <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
              {message}
            </Typography>
          ) : null}
          {/* {props.elementConfig.name !== "firstname" &&
          props.elementConfig.name !== "lastname" &&
          props.elementConfig.name !== "middlename" &&
          validateField(props) ? (
            <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
              {props.value.length === 0 ? props.errorMessage : message}
            </Typography>
          ) : null} */}
        </Aux>
      );
      break;
    case "inputNumber":
      inputElement = (
        <Aux>
          <div style={{ display: props.display }}>
            {/* <label
              htmlFor={props.elementConfig.name}
              style={{ fontSize: "12px", color: "#0000008a" }}
            >
              {props.elementConfig.label}
              {props.elementConfig.belowText ? (
                <div style={{ fontSize: "12px", color: "#0000008a" }}>
                  {props.elementConfig.belowText}
                </div>
              ) : null}
            </label> */}
               <TextField
              margin="normal"
              value={props.value}
              onChange={props.changed}
              {...props.elementConfig}
              color="secondary"
              InputProps={{
                endAdornment: props.icon,
              }}
              inputProps={{
                maxLength: props.maxLength ? props.maxLength : 50,
                ...(props.elementConfig.type === "number" && {
                  onKeyPress: (e) => {
                    if (!/^\d*$/.test(e.key)) {
                      e.preventDefault(); // Prevent non-numeric input
                    }
                  },
                }),
              }}
              style={{ display: props.display }}
            />
            {props.elementConfig.name !== "firstname" &&
            props.elementConfig.name !== "lastname" &&
            props.elementConfig.name !== "middlename" &&
            validateField(props) ? (
              <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
                {props.value.length === 0 ? props.errorMessage : message}
              </Typography>
            ) : null}
          </div>
        </Aux>
      );
      break;
    case "mobile":
      let countryName = undefined;
      let countryValue =
        props?.value?.substr(0, 1) !== undefined
          ? props?.value?.substr(0, 1) === "+"
            ? props?.value?.substr(1, 3)
            : ""
          : "";

      countryName =
        countryValue.length > 0
          ? countryValue?.substr(2, 1) === "-"
            ? countryCodes.findOne(
                "countryCallingCode",
                countryValue.substr(0, 2)
              )
            : countryCodes.findOne("countryCallingCode", countryValue)
          : undefined;
      inputElement = (
        <Aux>
          <FormGroup row style={{ display: "flex", width: "100%" }}>
            <Select
              value={countryName !== undefined ? countryName.countryCode : ""}
              onChange={(event) =>
                props.handleChange(event, props.elementConfig.name)
              }
              name={props.elementConfig.name}
              displayEmpty
              style={{
                display: "flex",
                alignItems: "flex-end",
                paddingBottom: "4px",
              }}
            >
              {countries.map((data, index) => {
                return (
                  <MenuItem key={index} value={data.iso2}>
                    <img
                      src={data.flag}
                      width="20px"
                      style={{ marginRight: "8px" }}
                    />
                    {data.name}
                  </MenuItem>
                );
              })}
            </Select>
            <TextField
              margin="normal"
              value={props.value}
              onChange={props.changed}
              {...props.elementConfig}
              color="secondary"
              className={classes.root}
              InputProps={{
                endAdornment: props.icon,
              }}
              inputProps={{
                maxLength: props.maxLength ? props.maxLength : 50,
              }}
              style={{ flex: "1", marginBottom: "0px" }}
            />
            {validateField(props) ? (
              <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
                {props.errorMessage}
              </Typography>
            ) : null}
          </FormGroup>
        </Aux>
      );
      break;
    case "date":
      inputElement = (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div style={{ display: props.display }}>
            <label
              htmlFor={props.elementConfig.name}
              style={{ fontSize: "12px", color: "#0000008a" }}
            >
              {props.elementConfig.label}
              <div style={{ fontSize: "12px", color: "#0000008a" }}>
              {localizedStrings.applicationpage.yearmonthdate}
              </div>
            </label>
            <KeyboardDatePicker
              margin="normal"
              format="yyyy/MM/dd"
              value={
                props.value === "" || props.value === null
                  ? null
                  : moment(props.value, "YYYY-MM-DD").toDate()
              }
              error={false}
              helperText={null} 
              maxDate={
                props.allowFutureDates
                  ? moment().add(20, "years").format()
                  : moment().subtract(0, "years").format()
              }
              onChange={(event) =>
                props.handelDateChange(event, props.elementConfig.name)
              }
              {...{ ...props.elementConfig, label: undefined }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              InputProps={{
                className: props.value == "" ? classes.datepicker : null,
              }}
              style={{ display: props.display }}
            />
          </div>
        </MuiPickersUtilsProvider>
      );
      break;
    case "exactDate":
      inputElement = (
        <MuiPickersUtilsProvider libInstance={moment} utils={DateFnsUtils}>
            <div style={{ display: props.display }}>
            <label
              htmlFor={props.elementConfig.name}
              style={{ fontSize: "12px", color: "#0000008a" }}
            >
              {props.elementConfig.label}
              <div style={{ fontSize: "12px", color: "#0000008a" }}>
              {localizedStrings.applicationpage.yearmonthdate}
              </div>
            </label>
          <KeyboardDatePicker
            margin="normal"
            format="yyyy-MM-dd"
            value={props.value === "" ? null : props.value}
            inputValue={props.value}
            error={false}
            helperText={null}
            maxDate={
              props.allowFutureDates
                ? moment().add(20, "years").format()
                : moment().subtract(0, "years").format()
            }
            onChange={(date, value) =>
              props.handelDateChangeEditable(
                date,
                value,
                props.elementConfig.name
              )
            }
            InputProps={{
              className: props.value == "" ? classes.datepicker : null,
            }}
            onInputChange={props.changed}
            {...{ ...props.elementConfig, label: undefined }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            style={{ display: props.display }}
          />
          </div>
        </MuiPickersUtilsProvider>
      );
      break;
    case "checkbox":
      inputElement = (
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.value}
                onChange={(event) =>
                  props.handleCheck(event, props.elementConfig.name)
                }
                name={props.elementConfig.name}
                style={{ fontSize: "0.5rem" }}
              />
            }
            label={props.elementConfig.label}
          />
        </FormGroup>
      );
      break;
    case "multiplecheckbox":
      inputElement = (
        <>
          <FormGroup>
            {props?.elementConfig?.options?.map((option) => (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props?.value?.includes(option.value)}
                      onChange={(event) =>
                        props.handleMultipleCheck(
                          event,
                          props.elementConfig.name,
                          option.value
                        )
                      }
                      name={option.label}
                    />
                  }
                  label={option.label}
                  key={option.value}
                />
                <br />
              </>
            ))}
          </FormGroup>
        </>
      );
      break;
    case "radio":
      inputElement = (
        <>
          <FormGroup>
            {props?.elementConfig?.options?.map((option) => (
              <React.Fragment key={option.value}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={props?.value === option.value}
                      onChange={(event) =>
                        props.handleRadioChange(
                          event,
                          props.elementConfig.name,
                          option.value,
                        )
                      }
                      name={props.elementConfig.name}
                      value={option.value}
                      style={{ fontSize: "0.5rem" }}
                    />
                  }
                  label={
                    <span dangerouslySetInnerHTML={{ __html: option.label }} />
                  }
                />
                <br />
              </React.Fragment>
            ))}
            {props?.elementConfig?.text && props?.value === "Coupon" && (
              <div
                dangerouslySetInnerHTML={{ __html: props.elementConfig.text }}
                style={{ fontWeight: "normal" }}
              />
            )}
          </FormGroup>
        </>
      );

      break;

    case "condition":
      inputElement = (
        <Aux>
          <Typography style={{ marginTop: "0.5rem" }}>
            • This application is only valid for the selected program.
          </Typography>
          <Typography>
            • The validity of this application is one year from the date of the
            submission.
          </Typography>
          <Typography>• The application fee is non-refundable</Typography>
          <Typography>
            • The schedule of choice in the application is for reference only,
            and ESLSCA reserves the right to publish classes with different
            schedules based upon our internal research and reports.
          </Typography>
          <Typography>
            • ESLSCAUniversity has the right to cancel this application without
            prior notice.
          </Typography>
          <Typography>
            • Decisions taken by ESLSCAUniversity are in good faith,based on the
            statements made in the students’ admission application, any false
            statements / omission of information discovered in the students’
            application, the University reserves the right to withdraw, amend
            its offer, or terminate the students’ registration at
            ESLSCAUniversity.
          </Typography>
          <Typography>• ESLSCAUniversity holds the right:</Typography>
          <ul>
            <li>
              For all the foregoing reasons, ESLSCA reserves the right not to
              provide any particular course, curriculum or facility to make
              variations to the content or method of delivery of courses, to
              discontinue courses and to merge or combine courses if such action
              is reasonably considered to be necessary by ESLSCA. If ESLSCA
              discontinues any course it will use reasonable endeavors to
              provide a suitable alternative and will take all reasonable steps
              to minimize any disruption that might result from such changes.
            </li>
            <li>
              Any offer of a place at ESLSCAUniversity is made on the
              understanding that; in accepting it the student undertakes to
              observe the Ordinances and Resolutions of the University and to
              abide by the rules and regulations that the University makes for
              its students from time to time. These currently include general
              disciplinary regulations and rules relating to examinations,
              libraries, and computing.
            </li>
          </ul>
        </Aux>
      );
      break;
    case "sectionHeader":
      inputElement = (
        <Aux>
          <div style={{
            padding: "0.9rem 0.7rem",
            margin: "1rem 0 0 0",
            background: "#005598",
            display: "flex",
            alignItems: "center",
            color: "#fff",
          }}>
            {localizedStrings.applicationpage[props.elementConfig.value]}
          </div>
        </Aux>
      );
      break;
    case "label":
      inputElement = (
        <Typography style={{ margin: "0.5rem 0" }}>
          {props.elementConfig.value}
        </Typography>
      );
      break;
    case "textArea":
      inputElement = (
        <Aux>
         {props.display === "block" &&
            props.elementConfig.aboveText && (
              <>{props.elementConfig.aboveText} <br/></>
            )}
         
        <div style={{ width: "100%", display: props.display }}>
          {props.elementConfig.label && (
            <label
              htmlFor={props.elementConfig.name}
              style={{
                fontSize: "0.95rem",
                fontWeight: 500,
                display: "block",
                marginBottom: "4px",
                color: "#555",
              }}
            >
              {props.elementConfig.label}
            </label>
          )}
          <TextareaAutosize
            id={props.elementConfig.name}
            aria-label="maximum height"
            placeholder=""
            {...props.elementConfig}
            value={props.value}
            onChange={props.handleChange}
            style={{
              width: "100%",
              height: "8vh",
              marginTop: "8px",
              fontSize: "0.95rem",
              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
            }}
          />
          {props.isValidate === true && validateTextArea(props) ? (
            <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
              {textareamessage}
            </Typography>
          ) : null}
        </div>
        </Aux>
      );
      break;
    case "select":
      inputElement = (
        <Aux>
          {props.elementConfig.display === "block" && (
            <>
              {props.elementConfig.aboveText && (
                <div dangerouslySetInnerHTML={{ __html: props.elementConfig.aboveText }} />
              )}
              {props.elementConfig.aboveText1 && (
                <>
                  <br />
                  {props.elementConfig.aboveText1}
                </>
              )}
            </>
          )}
          <FormControl
            {...props.elementConfig}
            style={{
              width: "100%",
              marginTop: "8px",
              marginBottom: "6px",
              display: props.elementConfig.display
                ? props.elementConfig.display
                : "block",
            }}
          >
            {/* <br /> */}
            <InputLabel id={props.elementConfig.label}>
              {props.elementConfig.label}
              {props.elementConfig.belowText && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: props.elementConfig.belowText,
                  }}
                />
              )}
            </InputLabel>
            <br />
            <Select
              value={props.value}
              onChange={(event) =>
                props.handleChange(event, props.elementConfig.name)
              }
              name={props.elementConfig.name}
              displayEmpty
              labelId={props.elementConfig.label}
              style={{
                width: "100%",
              }}
            >
              {props.elementConfig.options.map((data, index) => {
                return (
                  <MenuItem key={index} value={data.value}>
                    {data.displayValue}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          {props.elementConfig.display === 'block' && props.elementConfig.bottomText && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: props.elementConfig.bottomText,
                  }}
                />
              )}
        </Aux>
      );
      break;

    default:
      inputElement = (
        <TextField
          margin="normal"
          value={props.value}
          onChange={props.changed}
          {...props.elementConfig}
          color="secondary"
        />
      );
  }

  return <Aux>{inputElement}</Aux>;
};

export default InputFiled;
